import React from 'react';
import { motion } from 'framer-motion';

const METALLIC = {
  copper: 'glass-stat-bronze',
  forest: 'glass-stat-green',
  sage: 'glass-stat-green',
};

/** Console metallic KPI card */
export default function QawaemStatsCard({ label, value, icon: Icon, variant = 'copper', delay = 0, className = '' }) {
  const shell = METALLIC[variant] || METALLIC.copper;
  const title = label || '—';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className={className}
    >
      <div className={`${shell} p-6 transition-transform duration-300 hover:scale-[1.01]`}>
        <div className="relative z-[1] flex items-start justify-between gap-4">
          <div className="min-w-0 flex-1 text-start">
            <p className="glass-stat-label text-sm font-medium leading-snug">{title}</p>
            <p className="glass-stat-value text-2xl font-bold mt-2 tabular-nums leading-tight">{value}</p>
          </div>
          <div className="glass-stat-icon shrink-0 p-3 rounded-2xl self-start">
            <Icon className="h-6 w-6" aria-hidden />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
